const timeOfTheDayOptions = ['AM', 'PM'];

const HALF_OF_THE_DAY = 12;

const timeValues = Array.from({ length: HALF_OF_THE_DAY }, (_, index) => index);

export const DEFAULT_TIME_OPTION = '18';

export const timeOptions = timeOfTheDayOptions.flatMap(
  (partOfTheDay, partOfTheDayIndex) =>
    timeValues.map((hour) => {
      const value = partOfTheDayIndex === 0 ? hour : hour + HALF_OF_THE_DAY; // Convert to 24-hour format
      const label = hour === 0 ? HALF_OF_THE_DAY : hour; // Transform 0 => 12

      return {
        label: `${label}:00${partOfTheDay}`,
        value: `${value}`,
      };
    }),
);

export const timeLabelMapper = timeOfTheDayOptions.flatMap((partOfDay) =>
  timeValues.map((hour) => {
    const formattedHour = hour === 0 ? HALF_OF_THE_DAY : hour % HALF_OF_THE_DAY; // Convert 24-hour format to 12-hour format

    return `${formattedHour}${partOfDay}`;
  }),
);
